// Talks to GET /api/v1/user/menu. Returns the signed-in user's permission-filtered navigation tree
// (the identity.Menu parent-child hierarchy), rendered as the Fluent UI left navigation. The caller
// supplies the API bearer + identity hints (same shape as userClient/adminClient).
import { authHeaders, type AuthArgs } from './authArgs';

export interface MenuItem {
  id: number;
  title: string;
  icon?: string | null;
  url?: string | null;
  children: MenuItem[];
}

export async function getMenu(args: AuthArgs): Promise<MenuItem[]> {
  const res = await fetch('/api/v1/user/menu', { method: 'GET', headers: authHeaders(args) });
  if (!res.ok) {
    throw new Error(`menu ${res.status}: ${await res.text()}`);
  }
  return (await res.json()) as MenuItem[];
}
